import React, { Fragment } from 'react';
import { Route, Routes } from 'react-router-dom';
import { routes } from './Routes';
import AppLayout from '../Layout/Layout';

const LayoutRoutes = () => {

  return (
    <>
      <Routes>
        {routes.map(({ path, Component, element, children }, i) => {
          // If route has children and uses element (nested route structure)
          if (children && element) {
            return (
              <Route key={i} element={<AppLayout />}>
                <Route path={path} element={element}>
                  {children.map((child, j) => (
                    <Route key={j} path={child.path} element={child.element} />
                  ))}
                </Route>
              </Route>
            );
          }

          // Regular route with Component
          if (Component) {
            return (
              <Route key={i} element={<AppLayout />}>
                <Route path={path} element={Component} />
              </Route>
            );
          }

          // Route with element but no children
          if (element) {
            return (
              <Route key={i} element={<AppLayout />}>
                <Route path={path} element={element} />
              </Route>
            );
          }

          return null;
        })}
      </Routes>
    </>
  );
};

export default LayoutRoutes;